<template>
  <div>
    <div class="my-3 flex w-full items-start justify-start gap-x-2">
      <FilterDocumentBadge
        v-for="attachedFile in visibleDocuments"
        :key="attachedFile"
        :file="attachedFile"
        :selected-file="selectedFileFilters.includes(attachedFile)"
        :can-unlink="canUnlink"
        :can-attach="canAttach"
        @badge-clicked="onBadgeClicked"
        @document-unlinked="onDocumentUnlinked"
        @attach-selected="attachSelectedDocument"
      />
      <button
        v-if="hiddenDocuments.length"
        type="button"
        class="flex h-min items-center gap-x-2 whitespace-nowrap rounded-full bg-main-primary px-6 py-2 text-white"
        @click="showDocumentFilter = !showDocumentFilter"
      >
        <span>+{{ hiddenDocuments.length }}</span>
        <ChevronDownSmall :class="{ 'rotate-180': showDocumentFilter }" />
        <div class="flex gap-1">
          <div class="relative z-20">
            <div
              v-if="showDocumentFilter"
              class="absolute right-0 top-[105%] z-50 text-main-primary"
            >
              <div
                class="relative max-h-[300px] overflow-y-auto bg-white py-4 shadow-md"
              >
                <div
                  v-for="(attachedFile, fIndex) in hiddenDocuments"
                  :key="`file-${fIndex}-${attachedFile}`"
                  :class="`flex w-full items-center justify-between gap-x-6 px-6 py-3 text-left hover:bg-gray-50 ${selectedFileFilters.includes(attachedFile) ? 'bg-gray-200' : 'bg-white'}`"
                >
                  <div class="overflow-hidden text-ellipsis text-gray-500">
                    {{ getFileName(attachedFile) }}
                  </div>
                  <div
                    class="flex items-center justify-between gap-x-2 font-semibold"
                  >
                    <span
                      v-if="selectedFileFilters.includes(attachedFile)"
                      @click="handleFileFilter(attachedFile, 0)"
                    >
                      <FilterIcon />
                    </span>
                    <span
                      v-else
                      @click="handleFileFilter(attachedFile, 1)"
                    >
                      <FilterIcon />
                    </span>

                    <span
                      v-if="canAttach"
                      @click="attachSelectedDocument(attachedFile)"
                    >
                      <SelectDocumentIcon />
                    </span>
                    <span>
                      <UnlinkIcon custom-style="text-red-700 font-bold" />
                    </span>
                    <span>
                      <EyeIcon />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FileFilterDocumentSection',

  props: {
    files: {
      type: Array,
      required: true,
    },
    canUnlink: {
      type: Boolean,
      default: true,
    },
    canAttach: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['documentAttached', 'documentsFiltered', 'documentUnlinked'],

  data() {
    return {
      isClicked: false,
      showDocumentDropDown: false,
      showDocumentFilter: false,
      documentsList: this.files,
      selectedFileFilters: [],
    }
  },

  computed: {
    selectedFileNames() {
      return [...new Set(this.documentsList)]
    },
    visibleDocuments() {
      if (this.selectedFileFilters.length > 0) {
        const selectedRows = this.selectedFileNames.filter(row =>
          this.selectedFileFilters.includes(row),
        )
        const otherSelectedRows = this.selectedFileNames.filter(
          row => !this.selectedFileFilters.includes(row),
        )
        return [...selectedRows, ...otherSelectedRows].slice(0, 8)
      }
      else {
        return this.selectedFileNames.slice(0, 8)
      }
    },
    hiddenDocuments() {
      return this.selectedFileNames.filter(
        row => !this.visibleDocuments.includes(row),
      )
    },
  },

  watch: {
    files(newFiles) {
      this.documentsList = newFiles
    },
  },

  methods: {
    onBadgeClicked({ fileName, isClicked }) {
      if (isClicked) {
        this.selectedFileFilters.push(fileName)
      }
      else {
        const index = this.selectedFileFilters.indexOf(fileName)
        if (index !== -1) {
          this.selectedFileFilters.splice(index, 1)
        }
      }
      this.$emit('documentsFiltered', this.selectedFileFilters)
    },
    handleFileFilter(filename, status) {
      if (status) {
        this.selectedFileFilters.push(filename)
      }
      else {
        const index = this.selectedFileFilters.indexOf(filename)
        if (index > -1) {
          this.selectedFileFilters.splice(index, 1)
        }
      }
      this.$emit('documentsFiltered', this.selectedFileFilters)
    },
    onDocumentUnlinked(doc) {
      this.$emit('documentUnlinked', doc)
    },
    attachSelectedDocument(doc) {
      this.$emit('documentAttached', doc)
    },

    getFileName(file_name, maxLength = 20) {
      const segments = file_name.split('-')
      const fileName = segments[segments.length - 1]
      if (fileName.length <= maxLength) {
        return fileName
      }
      const extIndex = fileName.lastIndexOf('.')
      const extension = fileName.substring(extIndex)
      const nameWithoutExtension = fileName.substring(0, extIndex)
      const truncatedLength = maxLength - extension.length - 3
      const truncatedName
        = nameWithoutExtension.substring(0, truncatedLength) + '...'
      return truncatedName + extension
    },
  },
}
</script>
